module.exports = __webpack_public_path__ + "img/approval.8ffc73df.png";